import {
  SlButton
} from "./chunk.SBCFYC2S.js";

// src/components/button/button.ts
var button_default = SlButton;
SlButton.define("sl-button");

export {
  button_default
};
